import React from "react";
import styled from "@emotion/styled";
import { RootState, useAppSelector } from "src/common";
import { colors } from "src/theme";
import { useLocation } from "react-router-dom";

const ProgressBarStyle = styled.div<{ $headerDataVisible: boolean }>(({ $headerDataVisible }) => ({
  width: '100%',
  height: '7px',
  overflow: 'hidden',
  backgroundColor: $headerDataVisible ? colors.white : colors.background6,
}))

const ProgressStyle = styled.div((props: { progress: number }) => ({
  width: `${props.progress}%`,
  backgroundColor: colors.success1,
  height: '100%',
  borderRadius: '0 4px 4px 0',
  transition: 'width 0.3s ease' // Dodajte prijelaz za animaciju
}))

export const ProgressBar = ({ headerDataVisible }: { headerDataVisible: boolean }) => {
  const { pathname } = useLocation();
  const progressBarPercentage = useAppSelector((store: RootState) => store.state.progressBar.percentage);
  if (pathname.includes('ponude-agent')) {
    return null;
  }
  return (
    <ProgressBarStyle $headerDataVisible={headerDataVisible}>
      <ProgressStyle progress={progressBarPercentage}></ProgressStyle>
    </ProgressBarStyle>
  );
}
